"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                DocumentUpload_BrowseButtonLabel: "Browse",
                DocumentUpload_CancelButtonlabel: "Cancel",
                DocumentUpload_DocuTypeLabel: "Document Type",
                DocumentUpload_FileAccessError: "Critical Error: {0} .Possibly the file is open, please close it. Page will be refreshed",
                DocumentUpload_FileUploadCaption: "File to upload",
                DocumentUpload_NameLabel: "Name",
                DocumentUpload_NotesLabel: "Notes",
                DocumentUpload_UploadButtonLabel: "Upload",
                DocumentUpload_UploadStarted: "Document is being uploaded",
            },
        });
        var DocumentUpload = /** @class */ (function (_super) {
            __extends(DocumentUpload, _super);
            function DocumentUpload(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // Handler for when the browse button is clicked
                _this.BrowseButtonClicked = function () {
                    $dyn.observe($dyn.util.hasJQueryFileUploadLoaded, function (value) {
                        if (value) {
                            _this.setupJqUploader();
                            var control = _this.getFileUploadControl();
                            control.val("");
                            $dyn.setValue(_this, "selectedFile", "");
                            try {
                                control.click();
                            }
                            catch (err) {
                                _this.UploadFailure(err.message);
                            }
                        }
                        return false;
                    });
                };
                // Handler for when the upload button is clicked
                _this.UploadButtonClicked = function () {
                    $dyn.async.pending.increment("Upload document init");
                    var selectedFileName = $dyn.value(_this.selectedFile);
                    // Check the file conditions
                    if (!selectedFileName) {
                        _this.UploadFailure("");
                        return;
                    }
                    $dyn.getFunction(_this.CheckFile)([$dyn.value(_this.DocuName), selectedFileName], undefined, _this.PerformUpload);
                };
                /**
                 * Handles upload call failure.
                 * @param e The event object.
                 * @param data The response data.
                 */
                _this.handleFailure = function (e, data) {
                    _this.UploadFailure((data && data.jqXHR && data.jqXHR.responseJSON && data.jqXHR.responseJSON.ErrorMessage) || "");
                };
                /**
                 * Handles upload call success.
                 * @param e The event object.
                 * @param data The response data.
                 */
                _this.handleSuccess = function (e, data) {
                    if (data && data.result && data.result.length === 1) {
                        $dyn.setValue(_this, "UploadedFileId", data.result[0].fileId);
                    }
                    _this.UploadSuccess();
                };
                // Handler for when the file changes
                _this.FileChanged = function (e, data) {
                    var file = (data && data.files && data.files.length && data.files[0]) || {};
                    var fileName = file.name;
                    if (fileName && fileName.length > 0) {
                        fileName = $dyn.util.parseFileNameWithDirectory(fileName);
                    }
                    else {
                        fileName = "";
                    }
                    $dyn.setValue(_this, "selectedFile", fileName);
                    $dyn.setValue(_this, "DocuName", $dyn.util.GetFileNameWithoutExtension(fileName));
                    var needsChunking = file.size > $dyn.controls.documentConstants.DOCUMENT_UPLOAD_CHUNKING_SIZE_THRESHOLD;
                    _this.getFileUploadControl().fileupload("option", "maxChunkSize", needsChunking ? $dyn.controls.documentConstants.DEFAULT_CHUNK_SIZE : null);
                    // Set the submit upload action based on current context
                    _this.submitUploadAction = function () {
                        $.blueimp.fileupload.prototype.options.add.call(_this.getFileUploadControl(), e, data);
                    };
                    // Verify the document name and file type
                    $dyn.getFunction(_this.CheckFile)([$dyn.value(_this.DocuName), fileName], undefined, _this.FileChangedVerificationComplete);
                };
                /** Callback for when a file has changed and the verification is complete. */
                _this.FileChangedVerificationComplete = function () {
                    if ($dyn.value(_this.Style) === $dyn.ui.DocuUploadStyle.MinimalStyle && $dyn.value(_this.selectedFile)) {
                        // Call upload async to ensure the document name and file type validity flags have time to be updated on the control
                        $dyn.async(function () {
                            if ($dyn.value(_this.FileValid)) {
                                $dyn.async.pending.increment("Upload document init for minimal style");
                                _this.PerformUpload();
                            }
                        }, undefined, "File perform upload");
                    }
                };
                _this.PerformUpload = function () {
                    if (_this.submitUploadAction) {
                        if (!$dyn.value(_this.FileValid)) {
                            _this.UploadFailure("");
                            return;
                        }
                        if (!window.FileList) {
                            // UNSUPPORTED_BROWSER
                            _this.UploadFailure("");
                            return;
                        }
                        _this.isUploading(true);
                        var control = _this.getFileUploadControl();
                        _this.element.setAttribute("aria-busy", "true");
                        _this.element.setAttribute("aria-label", $dyn.label("DocumentUpload_UploadStarted"));
                        _this.element.setAttribute("aria-busy", "false");
                        var formDataArray = [
                            { name: "clientId", value: $dyn.util.generatePseudoId() },
                            { name: "maxChunkSize", value: $dyn.controls.documentConstants.DEFAULT_CHUNK_SIZE },
                            { name: "tableid", value: $dyn.value(_this.CurrentTableId) },
                            { name: "recid", value: $dyn.value(_this.CurrentRecId) },
                            { name: "companyid", value: $dyn.user().Company() },
                            { name: "accesstoken", value: $dyn.value(_this.AccessToken) },
                            { name: "notes", value: $dyn.value(_this.Notes) },
                            { name: "docuname", value: $dyn.value(_this.DocuName) },
                            { name: "docutypeid", value: $dyn.value(_this.SelectedDocumentType) },
                            { name: "ischunked", value: control.fileupload("option", "maxChunkSize") != null }
                        ];
                        var currentDocuRefRecId = $dyn.value(_this.CurrentDocuRefRecId);
                        if (currentDocuRefRecId) {
                            formDataArray.push({ name: "docuRefRecId", value: currentDocuRefRecId });
                        }
                        // Configure the file upload control based on the file size
                        control.fileupload("option", "formData", formDataArray);
                        _this.submitUploadAction();
                    }
                };
                // Load the jQuery file upload control file ondemand
                $dyn.util.loadJQueryFileUpload();
                _this.submitUploadAction = null;
                _this.isUploading = $dyn.observable(false);
                _this.buttonsEnabled = $dyn.computed(function () { return (!$dyn.value(_this.IsViewMode)) && $dyn.value(_this.Enabled) && (!$dyn.value(_this.isUploading)); });
                _this.selectedFile = $dyn.observable("");
                _this.UploadButtonEnabled = $dyn.computed(function () {
                    var file = $dyn.value(_this.selectedFile);
                    var enabled = !$dyn.value(_this.IsViewMode)
                        && $dyn.value(_this.buttonsEnabled)
                        && file
                        && file.length > 0
                        && $dyn.value(_this.FileValid);
                    return enabled;
                });
                _this.SubControlsAllowEdit = $dyn.computed(function () { return !$dyn.value(_this.IsViewMode) && $dyn.value(_this.buttonsEnabled); });
                _this.FileValid = $dyn.computed(function () { return $dyn.value(_this.DocuNameValidity) && $dyn.value(_this.FileTypeValidity); });
                return _this;
            }
            DocumentUpload.prototype.getFileUploadControl = function () {
                return $(this.element).find("[doc-upload-file-input=\"" + $dyn.value(this.Name) + "\"]");
            };
            /** Begins the performance timer. */
            DocumentUpload.prototype.beginPerformanceTimer = function () {
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("FileManagement");
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax();
            };
            /** Ends the performance timer. */
            DocumentUpload.prototype.endPerformanceTimer = function () {
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
            };
            /** Sets up the JQuery file upload control. */
            DocumentUpload.prototype.setupJqUploader = function () {
                this.reset();
                var control = this.getFileUploadControl();
                if (control && control.fileupload) {
                    control.fileupload({
                        // TODO: add progress with future work item (#241762) -> progressall
                        add: this.FileChanged,
                        always: this.endPerformanceTimer,
                        beforeSend: function (request) {
                            $dyn.serverForm.setCsrfToken(request);
                            request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                        },
                        dataType: "json",
                        done: this.handleSuccess,
                        fail: this.handleFailure,
                        limitConcurrentUploads: 3,
                        submit: this.beginPerformanceTimer,
                        url: $dyn.util.resolveVirtualPath("/filemanagement"),
                    });
                }
            };
            /** Resets the upload. */
            DocumentUpload.prototype.reset = function () {
                try {
                    this.submitUploadAction = null;
                    this.isUploading(false);
                    var control = this.getFileUploadControl();
                    if (control && control.fileupload) {
                        control.fileupload("destroy");
                    }
                }
                catch (ex) {
                    // No-op
                }
            };
            /** Callback for when the upload is successful. */
            DocumentUpload.prototype.UploadSuccess = function () {
                $dyn.async.pending.decrement("Upload document success");
                $dyn.getFunction(this.CloseDialog)();
                this.isUploading(false);
            };
            /**
             * Callback for when the upload fails.
             * @param specificMessage The specific failure message.
             */
            DocumentUpload.prototype.UploadFailure = function (specificMessage) {
                $dyn.async.pending.decrement("Upload document failure");
                $dyn.getFunction(this.UploadFailed)({ "_specificMessage": specificMessage });
                this.isUploading(false);
            };
            return DocumentUpload;
        }($dyn.ui.Control));
        controls.DocumentUpload = DocumentUpload;
        DocumentUpload.prototype.CurrentTableId = null;
        DocumentUpload.prototype.CurrentRecId = null;
        DocumentUpload.prototype.CurrentDocuRefRecId = null;
        DocumentUpload.prototype.AccessToken = null;
        DocumentUpload.prototype.Notes = "";
        DocumentUpload.prototype.DocuName = "";
        DocumentUpload.prototype.DocuNameValidity = false;
        DocumentUpload.prototype.FileTypeValidity = false;
        DocumentUpload.prototype.SelectedDocumentType = "";
        DocumentUpload.prototype.DocumentTypes = null;
        DocumentUpload.prototype.HideNotes = true;
        DocumentUpload.prototype.HideDocuName = true;
        DocumentUpload.prototype.UploadedFileId = "";
        DocumentUpload.prototype.Style = "";
        DocumentUpload.prototype.CloseDialog = null;
        DocumentUpload.prototype.UploadFailed = null;
        DocumentUpload.prototype.CheckFile = null;
        var DocUpload = /** @class */ (function (_super) {
            __extends(DocUpload, _super);
            function DocUpload() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return DocUpload;
        }($dyn.ui.Control));
        controls.DocUpload = DocUpload;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DocumentUpload.js.map
